// 永続（初回1回だけ）モジュール：副作用importを維持。
// 順序重要：smooth-scroll を最初に（getLenis を先に確定 → swup-init が参照する）。
import "./module/lib-smooth-scroll"
import "./module/comp-splash"
import "./module/cmn-a11y"
import "./module/cmn-acc"
import "./module/cmn-header-nav"
import "./module/cmn-form" // contact/form ページ専用（swup対象外なのでdocument宛CF7リスナーは累積しない）
import "./module/cmn-bg-noise"
import "./module/cmn-ios-chrome" // iOS Chromeのツールバー開閉を <html> クラスに反映（SP下部バーの嵩上げ用）

// swup 起動 + 毎ページモジュール（PageModule）のライフサイクル管理。
// header/footer（main外）の永続演出（fv-pulse footer / icon-hover persistent）もここで初回1回だけ mount する。
// ※必ず最後に import（永続モジュールの初期化後に swup を起動）。
import "./module/lib-swup-init"
